<template>
  <v-runtime-template :template="includeTemplate"/>
</template>

<script>
import VRuntimeTemplate from 'v-runtime-template'
import wepHtmlToString from '@/plugins/_common/WepHtmlToString'
import { isEmpty } from 'lodash'

export default {
  name: 'Complete',
  components: {
    VRuntimeTemplate
  },
  props: {
    rltMsg: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      includeHtml: '',
      basePath: this.getStore('mmpAuth').state.basePath
    }
  },
  computed: {
    includeTemplate () {
      return this.includeHtml
    }
  },
  watch: {
  },
  beforeUpdate () {
  },
  updated () {
  },
  async created () {
    if (isEmpty(wepHtmlToString.thirdSubTemplate)) {
      this.getEmptyTemplate('wepComplete.html')
    } else {
      this.includeHtml = wepHtmlToString.thirdSubTemplate
    }
  },
  methods: {
    getEmptyTemplate (resourceUrl) {
      resourceUrl = this.getTemplatePath(resourceUrl)
      this.$http.loadRes(resourceUrl).then( (res) => {
        wepHtmlToString.thirdSubTemplate = res
        this.includeHtml = wepHtmlToString.thirdSubTemplate
      })
    },
    fnConfirm () {
      this.$emit('confirm', '3')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/contents/main/Complete.vue